module.exports = __webpack_public_path__ + "img/email_icon_selected.bb771d9c.svg";